import SearchParamsBase from '../../../Elements/SearchParamsBase';

export default class FraudHitMatchSearchParams extends SearchParamsBase {
  static iconName = 'fa-solid fa-search';
  static saveType = 'FraudHitMatchSearchParams';

  initialize(fraudHitEvaluatorId) {
    this.FraudHitEvaluatorId = fraudHitEvaluatorId;
  }

  static fieldsInSearchBox = [
    // { fieldName: 'RecordId', label: 'Record ID', className: 'col-4', type: InputTypesEnum.Number },
  ];
}
